import styled from '@emotion/styled';

import COLOR from '../../../../../shared/constant/colorset';

export const View = styled.div<{ hasReviewList: boolean }>`
  position: relative;
  width: 100%;
  margin-top: ${({ hasReviewList }) => (hasReviewList ? '34px' : 0)};
  border-top: 1px solid ${COLOR.kurlyGray800};
`;

export const ListHeader = styled.div`
  position: absolute;
  top: -36px;
  width: 100%;
  font-size: 12px;
  line-height: 16px;
`;

export const TotalCount = styled.span`
  position: absolute;
  left: 0;
  font-weight: 500;
`;

export const SortButtonWrapper = styled.div`
  display: flex;
  gap: 17px;
  align-items: center;
  justify-content: flex-end;
  font-weight: 400;
`;

export const SortButton = styled.button<{ isSelected: boolean }>`
  position: relative;
  font-weight: ${(props) => (props.isSelected ? 500 : 400)};
  font-size: 12px;
  color: ${(props) => (props.isSelected ? COLOR.kurlyGray800 : COLOR.kurlyGray450)};

  ::after {
    content: '';
    position: absolute;
    top: 4px;
    height: 62.5%;
    border-left: 1px solid ${COLOR.kurlyGray450};
    margin-left: 8px;
    margin-right: 8px;
  }

  :last-of-type::after {
    display: none;
  }
`;

export const FallbackView = styled.div`
  position: relative;
  width: 100%;
  padding-top: 119px;
`;

export const EmptyFallback = styled(FallbackView)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const EmptyText = styled.p`
  margin-top: 15px;
  margin-bottom: 28px;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: ${COLOR.kurlyGray400};
`;

export const Pagination = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  padding-top: 20px;
`;

const Button = styled.button`
  width: 44px;
  height: 44px;
  padding: 0;
  margin: 0;
  border: 0;
  cursor: pointer;
  background-color: transparent;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const ReviewableButton = styled(Button)`
  width: 138px;
  border-radius: 22px;
  background-color: ${COLOR.kurlyPurple};
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${COLOR.kurlyWhite};
`;

export const PreviousButton = styled(Button)`
  background-image: url('https://res.kurly.com/kurly/ico/2021/paging-prev-activated.svg');

  &:hover {
    background-image: url('https://res.kurly.com/kurly/ico/2021/paging-prev-hover.svg');
  }

  &:disabled {
    background-image: url('https://res.kurly.com/kurly/ico/2021/paging-prev-disabled.svg');
    cursor: default;
  }
`;

export const NextButton = styled(Button)`
  background-image: url('https://res.kurly.com/kurly/ico/2021/paging-next-activated.svg');

  &:hover {
    background-image: url('https://res.kurly.com/kurly/ico/2021/paging-next-hover.svg');
  }

  &:disabled {
    background-image: url('https://res.kurly.com/kurly/ico/2021/paging-next-disabled.svg');
    cursor: default;
  }
`;

export const ListSectionTop = styled.div`
  position: absolute;
  top: -170px;
  height: 0;
`;
